export default __webpack_public_path__ + "static/char-t-20-zh-Hans-56c1249b0c6794466ab869efd1584e78.png";